<template>
  <v-dialog v-model="relatedTaskDialog">
    <template #activator="{ on: dialog }">
      <v-tooltip bottom>
        <template #activator="{ on: tooltip }">
          <v-btn
            flat
            icon
            :loading="relatedTaskLoader"
            v-on="{ ...tooltip, ...dialog }"
            @click="getRelatedTask"
          >
            <v-icon>list</v-icon>
          </v-btn>
        </template>
        <span>Show Related Tasks</span>
      </v-tooltip>
    </template>
    <v-card class="beez-card" v-if="selectedTaskId === taskId">
      <v-toolbar class="beez-bold body-2" dense card>
        Show Related Tasks
        <v-spacer />
        <v-btn icon flat @click="relatedTaskDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
        <v-progress-linear
          color="accent"
          indeterminate
          v-if="relatedTaskLoader"
        ></v-progress-linear>
        <v-layout row fill-height class="py-0">
          <v-flex v-if="relatedTasks && relatedTasks.length > 0">
            <template v-for="(task, i) in relatedTasks">
              <task-card-display
                :key="i + '_task_display_card'"
                :task="task"
                :show-time="showTime"
              ></task-card-display>
            </template>
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
          <v-alert
            v-else
            :value="true"
            color="success"
            icon="info"
            style="border-radius: 5px;"
          >
            No Related Task found</v-alert
          >
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import TaskCardDisplay from '@/components/task-lists/TaskCardDisplay'
export default {
  name: 'RelatedTaskTimeline',
  components: {
    TaskCardDisplay
  },
  data() {
    return {
      selectedTaskId: null,
      relatedTaskDialog: false,
      relatedTaskLoader: false,
      page: 1,
      pageCount: 0
    }
  },
  props: {
    taskId: String,
    showTime: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      relatedTasks: state => state.tasks.relatedTasks
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  watch: {
    page() {
      this.getRelatedTask()
    }
  },
  methods: {
    async getRelatedTask() {
      this.relatedTaskLoader = true
      await this.$store.dispatch('resetRelatedTask')
      if (this.taskId) {
        this.selectedTaskId = this.taskId
        let userTask = await this.$store.dispatch(
          'returnTasksDetails',
          this.taskId
        )
        if (userTask && userTask.externalId) {
          let urlParams = `page=${this.page}&sort=changedAt&size=10&externalId=${userTask.externalId}`
          let count = await this.$store.dispatch(
            'fetchTasksCount',
            `externalId=${userTask.externalId}`
          )
          this.pageCount = Math.ceil(count / 10)
          await this.$store.dispatch('fetchRelatedTasks', urlParams)
        }
      }
      this.relatedTaskLoader = false
    }
  }
}
</script>

<style scoped></style>
